import { useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import { useMutation, useQuery } from "react-query";
import ValidatingAttendancesByManager from "./useValidatingAttendancesByManagerService";
import { message } from "antd";
import dayjs from "dayjs";

const useValidatingAttendancesByManager = (dateFilter) => {
  const { id: trainingId } = useParams();
  const sessionDate = dayjs(dateFilter).format('YYYY-MM-DD');
  const fetchData = useCallback(
    async () => {
      try {
        const response = await ValidatingAttendancesByManager.getAttendancesByTrainingIdAndDate(
          trainingId,
          sessionDate  
        );
        return response;
      } catch (error) {
        console.error('Error in fetchData:', error);
        throw error;
      }
    },
    [trainingId,sessionDate] 
  );
  
  const { data, isFetching, refetch } = useQuery(
    ["attendancesTrainingByCurrentDate", trainingId, sessionDate], 
    fetchData
  );
  const [dataChangeStatus, setDataChangeStatus] = useState(data?.data);

  const handleToggle = (index, sessionIndex) => {

    const updatedDataStatus = [...data?.data];
  
    const record = updatedDataStatus[index];
    const attendance = record.sessions[sessionIndex].attendances[0];
    attendance.status = attendance.status === "present" ? "absent" : "present";
    attendance.isValidated = true;
    setDataChangeStatus(updatedDataStatus);
  };

  const updatedDataForValidation = {
    attendances: data?.data.flatMap((record) =>
      record.sessions?.flatMap((session) =>
        session.attendances.map((attendance) => ({
          id: attendance.id,
          isValidated: true,
          status: attendance.status,
        }))
      )
    ),
  };

  const validateAttendancesMutation = useMutation(
    () => ValidatingAttendancesByManager.validateAttendance(updatedDataForValidation),
    {
      onSuccess: () =>{
        message.success('successful validation');
        refetch()
      },
      onError: () =>{
      message.success('Error when submitting');
     }
    }
  );

  const handleValidateAttendances = async () => {
    try {
      await validateAttendancesMutation.mutateAsync();
    } catch (error) {
      console.error(error);
    }
  };

  return { data: data?.data, isFetching, refetch, handleValidateAttendances, handleToggle, dataChangeStatus };
};

export default useValidatingAttendancesByManager;
